import React  from 'react';
import AccredList from "./components/accredlist";
 import { BrowserRouter } from "react-router-dom";
import HeaderContent from './components/headercontent';
import HeaderSubContent from './components/headersubcontent';
import Redirect from './components/redirect';

function App() {
  const accesibilityStyling = {
    textAlign: "center",
    width: "100%",
     marginTop: "3%",
      marginBottom: "2%"}

      const hostname = window.location.hostname;

      const useRedirect = hostname.includes('stdweb02');

  return (
     <BrowserRouter>
               <HeaderContent />

      <main className="container">
        {useRedirect ? <Redirect/> : <div><HeaderSubContent /> <AccredList /></div>}
      
      </main>
      <footer style={accesibilityStyling}>
        <a href="https://cdle.colorado.gov/accessibility" target="_blank" alt="Colorado Office of Information Technology Accessibility Statement">Accessibility Statement</a>
    </footer> 
     </BrowserRouter>
  );
}

export default App;
